import { cva as e } from "class-variance-authority";
// src/design/avatar/style.ts
var t = e([
	"overflow-hidden",
	"flex",
	"items-center",
	"justify-center",
	"font-medium",
	"bg-muted",
	"text-foreground"
], {
	variants: {
		size: {
			xs: "w-6 h-6 text-xs",
			sm: "w-8 h-8 text-sm",
			md: "w-10 h-10 text-base",
			lg: "w-12 h-12 text-md",
			xl: "w-16 h-16 text-lg",
			"2xl": "w-20 h-20 text-xl"
		},
		variant: {
			circular: "rounded-full",
			rounded: "rounded-lg",
			square: "rounded-md"
		},
		border: {
			true: "ring-2 ring-border",
			false: ""
		},
		shadow: {
			true: "shadow-lg",
			false: ""
		}
	},
	defaultVariants: {
		size: "md",
		variant: "circular",
		border: !1,
		shadow: !1
	}
}), n = e([
	"w-full",
	"h-full",
	"object-cover"
]), r = [
	"w-full",
	"h-full",
	"flex",
	"items-center",
	"justify-center",
	"font-semibold",
	"select-none"
], i = {
	jade: "bg-jade-600",
	teal: "bg-jade-500",
	plum: "bg-recruitment-700",
	magenta: "bg-magenta-700",
	lime: "bg-lime-700",
	amber: "bg-amber-brand-700",
	slate: "bg-neutral-700",
	ink: "bg-neutral-900"
}, a = e([...r, "text-white"], {
	variants: { tint: i },
	defaultVariants: { tint: "jade" }
}), o = e([
	"absolute",
	"-bottom-0",
	"-right-0",
	"rounded-full",
	"border-2",
	"border-background"
], {
	variants: {
		size: {
			xs: "w-1.5 h-1.5",
			sm: "w-2 h-2",
			md: "w-2.5 h-2.5",
			lg: "w-3 h-3",
			xl: "w-4 h-4",
			"2xl": "w-5 h-5"
		},
		status: {
			online: "bg-success",
			offline: "bg-muted-foreground",
			away: "bg-warning",
			busy: "bg-destructive"
		}
	},
	defaultVariants: {
		size: "md",
		status: "online"
	}
}), s = e(["relative", "inline-block"]), c = e([...r, "text-white"], {
	variants: { colorScheme: {
		blue: i.jade,
		green: i.lime,
		indigo: i.plum,
		pink: i.magenta,
		rose: i.magenta,
		amber: i.amber,
		gray: i.slate,
		ink: i.ink
	} },
	defaultVariants: { colorScheme: "ink" }
});
function l(e) {
	return {
		root: (n) => t({
			...e,
			...n
		}),
		image: () => n(),
		fallback: (e) => a({ tint: e }),
		plainFallback: (e) => c({ colorScheme: e }),
		status: (t) => o({
			size: e?.size,
			...t
		}),
		container: () => s()
	};
}
function u(e) {
	if (!e) return "";
	let t = e.trim().split(/\s+/);
	return t.length === 1 ? (t[0] || "").slice(0, 2).toUpperCase() : ((t[0] || "").charAt(0) + (t[t.length - 1] || "").charAt(0)).toUpperCase();
}
var d = [
	"blue",
	"green",
	"indigo",
	"pink",
	"rose",
	"amber",
	"gray"
];
function f(e) {
	let t = 0;
	for (let n = 0; n < e.length; n++) t = (t << 5) - t + e.charCodeAt(n), t |= 0;
	return Math.abs(t);
}
function p(e) {
	return e ? d[f(e) % d.length] : "gray";
}
var m = Object.keys(i);
function h(e) {
	return e ? m[f(e) % m.length] : "slate";
}
export { p as getColorScheme, u as getInitials, l as getStyles, h as getTint };

//# sourceMappingURL=style.js.map